import { ActivityTag } from './types';
import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface ActivityTagsProps {
  tags: ActivityTag[];
}

/**
 * ActivityTags Component
 * 
 * Horizontal list of activity tags with bullet dividers.
 * Responsive: Tag text scales 12px → 13px → 14px.
 */
export default function ActivityTags({ tags }: ActivityTagsProps) {
  return (
    <div className="flex items-center flex-wrap gap-1.5">
      {tags.map((tag, index) => (
        <div key={tag.id} className="flex items-center gap-1.5">
          <span
            className={`${ACTIVITY_DETAILS_TYPOGRAPHY.caption.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.caption.sizeClasses}`}
            style={{
              fontFamily: 'DM Sans, sans-serif',
              color: ACTIVITY_DETAILS_COLORS.tagText,
            }}
          >
            {tag.label}
          </span>
          {index < tags.length - 1 && (
            <div
              className="rounded-full"
              style={{
                width: '2px',
                height: '2px',
                backgroundColor: ACTIVITY_DETAILS_COLORS.tagDivider,
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
